import React from "react";

// Type definition for SVG icon components
type IconComponent = React.FC<React.SVGProps<SVGSVGElement>>;

export const ResetSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.8248 2.5752C5.88067 2.63093 5.92501 2.69714 5.95525 2.77004C5.9855 2.84293 6.00107 2.92108 6.00107 3C6.00107 3.07892 5.9855 3.15706 5.95525 3.22996C5.92501 3.30285 5.88067 3.36906 5.8248 3.4248L4.4484 4.8H10.8C12.2322 4.8 13.6057 5.36893 14.6184 6.38162C15.6311 7.39432 16.2 8.76783 16.2 10.2C16.2 11.6322 15.6311 13.0057 14.6184 14.0184C13.6057 15.0311 12.2322 15.6 10.8 15.6H6C5.84087 15.6 5.68826 15.5368 5.57573 15.4243C5.46321 15.3117 5.4 15.1591 5.4 15C5.4 14.8409 5.46321 14.6883 5.57573 14.5757C5.68826 14.4632 5.84087 14.4 6 14.4H10.8C11.9139 14.4 12.9822 13.9575 13.7698 13.1698C14.5575 12.3822 15 11.3139 15 10.2C15 9.08609 14.5575 8.0178 13.7698 7.23015C12.9822 6.4425 11.9139 6 10.8 6H4.4484L5.8248 7.3752C5.88058 7.43098 5.92484 7.49721 5.95503 7.5701C5.98522 7.64299 6.00076 7.72111 6.00076 7.8C6.00076 7.87889 5.98522 7.95701 5.95503 8.0299C5.92484 8.10279 5.88058 8.16901 5.8248 8.2248C5.76901 8.28058 5.70279 8.32484 5.6299 8.35503C5.55701 8.38522 5.47889 8.40076 5.4 8.40076C5.32111 8.40076 5.24299 8.38522 5.1701 8.35503C5.09721 8.32484 5.03098 8.28058 4.9752 8.2248L2.5752 5.8248C2.51932 5.76906 2.47499 5.70285 2.44474 5.62996C2.4145 5.55706 2.39893 5.47892 2.39893 5.4C2.39893 5.32108 2.4145 5.24293 2.44474 5.17004C2.47499 5.09714 2.51932 5.03093 2.5752 4.9752L4.9752 2.5752C5.03093 2.51932 5.09714 2.47499 5.17004 2.44474C5.24293 2.4145 5.32108 2.39893 5.4 2.39893C5.47892 2.39893 5.55706 2.4145 5.62996 2.44474C5.70285 2.47499 5.76906 2.51932 5.8248 2.5752Z"
			fill="#3F3F46"
		/>
	</svg>
);

export const FilterSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
	>
		<path
			d="M2.25 3.375L7.65 9.68175V14.4165L10.35 15.75V9.68175L15.75 3.375H2.25Z"
			stroke="#3F3F46"
			strokeWidth="1.2"
			strokeLinejoin="round"
		/>
	</svg>
);

export const PieSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
	>
		<g clipPath="url(#clip0_362_44041)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.4375 0.875H7.875C9.26739 0.875 10.6027 1.42812 11.5873 2.41269C12.5719 3.39726 13.125 4.73261 13.125 6.125V6.5625H7.4375V0.875ZM6.55988 0.875V7.44013H13.1259L13.0471 7.94413C12.8078 9.46587 12.0036 10.8415 10.7951 11.7967C9.58652 12.7519 8.06234 13.2164 6.52646 13.0978C4.99058 12.9791 3.55587 12.2858 2.50841 11.1563C1.46095 10.0268 0.877714 8.54395 0.875 7.0035C0.87528 5.54288 1.39752 4.13043 2.34751 3.02096C3.2975 1.91148 4.61271 1.17802 6.05587 0.952875L6.55988 0.875ZM5.68488 7.735V1.9215C4.774 2.15755 3.9433 2.63406 3.27971 3.30119C2.61612 3.96832 2.14402 4.80153 1.91281 5.71365C1.68161 6.62577 1.6998 7.58326 1.96547 8.48594C2.23115 9.38862 2.73455 10.2033 3.423 10.8448L5.68488 7.735ZM4.1125 11.3864C4.81006 11.8452 5.607 12.131 6.43716 12.2202C7.26732 12.3093 8.10677 12.1992 8.88584 11.8989C9.6649 11.5986 10.3611 11.1168 10.9167 10.4935C11.4722 9.87024 11.8711 9.12345 12.0802 8.31513H6.3455L4.1125 11.3864Z"
				fill="#0E49B5"
			/>
		</g>
		<defs>
			<clipPath id="clip0_362_44041">
				<rect width="14" height="14" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

export const FoodSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14"
		height="14"
		viewBox="0 1 14 14"
		fill="none"
	>
		<path
			d="M10.8564 14H11.9127C12.4473 14 12.8864 13.5864 12.95 13.0645L14 2.57727H10.8182V0H9.56455V2.57727H6.40182L6.59273 4.06636C7.68091 4.36545 8.69909 4.90636 9.31 5.50455C10.2264 6.40818 10.8564 7.34364 10.8564 8.87091V14ZM0 13.3636V12.7273H9.56455V13.3636C9.56455 13.7073 9.27818 14 8.90909 14H0.636364C0.286364 14 0 13.7073 0 13.3636ZM9.56455 8.90909C9.56455 3.81818 0 3.81818 0 8.90909H9.56455ZM0 10.1818H9.54545V11.4545H0V10.1818Z"
			fill="#0E49B5"
		/>
	</svg>
);

export const ImgSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
	>
		<path
			d="M4.95833 7.875L6.41667 9.625L8.45833 7L11.0833 10.5H2.91667M12.25 11.0833V2.91667C12.25 2.60725 12.1271 2.3105 11.9083 2.09171C11.6895 1.87292 11.3928 1.75 11.0833 1.75H2.91667C2.60725 1.75 2.3105 1.87292 2.09171 2.09171C1.87292 2.3105 1.75 2.60725 1.75 2.91667V11.0833C1.75 11.3928 1.87292 11.6895 2.09171 11.9083C2.3105 12.1271 2.60725 12.25 2.91667 12.25H11.0833C11.3928 12.25 11.6895 12.1271 11.9083 11.9083C12.1271 11.6895 12.25 11.3928 12.25 11.0833Z"
			fill="#0E49B5"
		/>
	</svg>
);

export const StatisticSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
	>
		<path
			d="M3 10H7V17H3V10ZM10 7H14V20H10V7Z"
			stroke="#3F3F46"
			strokeWidth="2"
			strokeLinejoin="round"
		/>
		<path
			d="M12 22V20"
			stroke="#3F3F46"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M17 6H21V10.5H17V6Z"
			stroke="#3F3F46"
			strokeWidth="2"
			strokeLinejoin="round"
		/>
		<path
			d="M5 10V5M19 17V10.5M19 6V2"
			stroke="#3F3F46"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const EditSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14"
		height="16"
		viewBox="0 -2 14 16"
		fill="none"
	>
		<path
			d="M1 13H13"
			stroke="currentColor"
			strokeOpacity="0.75"
			strokeWidth="1.2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M3.6665 10.3333V7.66667L10.3332 1L12.9998 3.66667L6.33317 10.3333H3.6665Z"
			stroke="currentColor"
			strokeOpacity="0.75"
			strokeWidth="1.2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M8.3335 3L11.0002 5.66667"
			stroke="currentColor"
			strokeOpacity="0.75"
			strokeWidth="1.2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const SaveListSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="17"
		viewBox="0 -1 16 16"
		fill="none"
	>
		<path
			d="M4.5 4.65C4.5 3.81 4.5 3.39 4.6635 3.069C4.80731 2.78677 5.03677 2.55731 5.319 2.4135C5.64 2.25 6.06 2.25 6.9 2.25H11.1C11.94 2.25 12.36 2.25 12.681 2.4135C12.9632 2.55731 13.1927 2.78677 13.3365 3.069C13.5 3.39 13.5 3.81 13.5 4.65V14.6287C13.5 14.9932 13.5 15.1755 13.4243 15.2753C13.3915 15.3186 13.3497 15.3544 13.3018 15.38C13.2539 15.4057 13.201 15.4206 13.1467 15.4238C13.0215 15.4313 12.87 15.33 12.567 15.1282L9 12.75L5.433 15.1275C5.13 15.33 4.9785 15.4313 4.8525 15.4238C4.79838 15.4205 4.74561 15.4055 4.69783 15.3799C4.65005 15.3542 4.6084 15.3185 4.57575 15.2753C4.5 15.1755 4.5 14.9932 4.5 14.6287V4.65Z"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.2"
		/>
	</svg>
);

export const TrashSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
	>
		<path
			d="M5.8335 17.5C5.37517 17.5 4.98294 17.3369 4.65683 17.0108C4.33072 16.6847 4.16739 16.2922 4.16683 15.8333V5C3.93072 5 3.73294 4.92 3.5735 4.76C3.41405 4.6 3.33405 4.40222 3.3335 4.16667C3.33294 3.93111 3.41294 3.73333 3.5735 3.57333C3.73405 3.41333 3.93183 3.33333 4.16683 3.33333H7.50017C7.50017 3.09722 7.58017 2.89944 7.74017 2.74C7.90017 2.58056 8.09794 2.50056 8.3335 2.5H11.6668C11.9029 2.5 12.101 2.58 12.261 2.74C12.421 2.9 12.5007 3.09778 12.5002 3.33333H15.8335C16.0696 3.33333 16.2677 3.41333 16.4277 3.57333C16.5877 3.73333 16.6674 3.93111 16.6668 4.16667C16.6663 4.40222 16.5863 4.60028 16.4268 4.76083C16.2674 4.92139 16.0696 5.00111 15.8335 5V15.8333C15.8335 16.2917 15.6704 16.6842 15.3443 17.0108C15.0182 17.3375 14.6257 17.5006 14.1668 17.5H5.8335ZM14.1668 5H5.8335V15.8333H14.1668V5ZM8.3335 14.1667C8.56961 14.1667 8.76767 14.0867 8.92767 13.9267C9.08767 13.7667 9.16739 13.5689 9.16683 13.3333V7.5C9.16683 7.26389 9.08683 7.06611 8.92683 6.90667C8.76683 6.74722 8.56905 6.66722 8.3335 6.66667C8.09794 6.66611 7.90017 6.74611 7.74017 6.90667C7.58017 7.06722 7.50017 7.265 7.50017 7.5V13.3333C7.50017 13.5694 7.58017 13.7675 7.74017 13.9275C7.90017 14.0875 8.09794 14.1672 8.3335 14.1667ZM11.6668 14.1667C11.9029 14.1667 12.101 14.0867 12.261 13.9267C12.421 13.7667 12.5007 13.5689 12.5002 13.3333V7.5C12.5002 7.26389 12.4202 7.06611 12.2602 6.90667C12.1002 6.74722 11.9024 6.66722 11.6668 6.66667C11.4313 6.66611 11.2335 6.74611 11.0735 6.90667C10.9135 7.06722 10.8335 7.265 10.8335 7.5V13.3333C10.8335 13.5694 10.9135 13.7675 11.0735 13.9275C11.2335 14.0875 11.4313 14.1672 11.6668 14.1667Z"
			fill="#3F3F46"
		/>
	</svg>
);

export const TrashRedSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
	>
		<path
			d="M5.8335 17.5C5.37517 17.5 4.98294 17.3369 4.65683 17.0108C4.33072 16.6847 4.16739 16.2922 4.16683 15.8333V5C3.93072 5 3.73294 4.92 3.5735 4.76C3.41405 4.6 3.33405 4.40222 3.3335 4.16667C3.33294 3.93111 3.41294 3.73333 3.5735 3.57333C3.73405 3.41333 3.93183 3.33333 4.16683 3.33333H7.50017C7.50017 3.09722 7.58017 2.89944 7.74017 2.74C7.90017 2.58056 8.09794 2.50056 8.3335 2.5H11.6668C11.9029 2.5 12.101 2.58 12.261 2.74C12.421 2.9 12.5007 3.09778 12.5002 3.33333H15.8335C16.0696 3.33333 16.2677 3.41333 16.4277 3.57333C16.5877 3.73333 16.6674 3.93111 16.6668 4.16667C16.6663 4.40222 16.5863 4.60028 16.4268 4.76083C16.2674 4.92139 16.0696 5.00111 15.8335 5V15.8333C15.8335 16.2917 15.6704 16.6842 15.3443 17.0108C15.0182 17.3375 14.6257 17.5006 14.1668 17.5H5.8335ZM14.1668 5H5.8335V15.8333H14.1668V5ZM8.3335 14.1667C8.56961 14.1667 8.76767 14.0867 8.92767 13.9267C9.08767 13.7667 9.16739 13.5689 9.16683 13.3333V7.5C9.16683 7.26389 9.08683 7.06611 8.92683 6.90667C8.76683 6.74722 8.56905 6.66722 8.3335 6.66667C8.09794 6.66611 7.90017 6.74611 7.74017 6.90667C7.58017 7.06722 7.50017 7.265 7.50017 7.5V13.3333C7.50017 13.5694 7.58017 13.7675 7.74017 13.9275C7.90017 14.0875 8.09794 14.1672 8.3335 14.1667ZM11.6668 14.1667C11.9029 14.1667 12.101 14.0867 12.261 13.9267C12.421 13.7667 12.5007 13.5689 12.5002 13.3333V7.5C12.5002 7.26389 12.4202 7.06611 12.2602 6.90667C12.1002 6.74722 11.9024 6.66722 11.6668 6.66667C11.4313 6.66611 11.2335 6.74611 11.0735 6.90667C10.9135 7.06722 10.8335 7.265 10.8335 7.5V13.3333C10.8335 13.5694 10.9135 13.7675 11.0735 13.9275C11.2335 14.0875 11.4313 14.1672 11.6668 14.1667Z"
			fill="#df0101"
		/>
	</svg>
);

export const HolderSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.9917 18C12.9917 16.8954 13.8871 16 14.9917 16H15.0007C16.1053 16 17.0007 16.8954 17.0007 18C17.0007 19.1046 16.1053 20 15.0007 20H14.9917C13.8871 20 12.9917 19.1046 12.9917 18Z"
			fill="#D4D4D8"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.99561 18C6.99561 16.8954 7.89104 16 8.99561 16H9.00459C10.1092 16 11.0046 16.8954 11.0046 18C11.0046 19.1046 10.1092 20 9.00459 20H8.99561C7.89104 20 6.99561 19.1046 6.99561 18Z"
			fill="#D4D4D8"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.9919 12C12.9919 10.8954 13.8873 10 14.9919 10H15.0009C16.1054 10 17.0009 10.8954 17.0009 12C17.0009 13.1046 16.1054 14 15.0009 14H14.9919C13.8873 14 12.9919 13.1046 12.9919 12Z"
			fill="#D4D4D8"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.9958 6C12.9958 4.89543 13.8912 4 14.9958 4H15.0048C16.1093 4 17.0048 4.89543 17.0048 6C17.0048 7.10457 16.1093 8 15.0048 8H14.9958C13.8912 8 12.9958 7.10457 12.9958 6Z"
			fill="#D4D4D8"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.99561 12C6.99561 10.8954 7.89104 10 8.99561 10H9.00459C10.1092 10 11.0046 10.8954 11.0046 12C11.0046 13.1046 10.1092 14 9.00459 14H8.99561C7.89104 14 6.99561 13.1046 6.99561 12Z"
			fill="#D4D4D8"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.99561 6C6.99561 4.89543 7.89104 4 8.99561 4H9.00459C10.1092 4 11.0046 4.89543 11.0046 6C11.0046 7.10457 10.1092 8 9.00459 8H8.99561C7.89104 8 6.99561 7.10457 6.99561 6Z"
			fill="#D4D4D8"
		/>
	</svg>
);

export const LocationSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.2058 17.4742C11.1643 16.6045 12.0513 15.6592 12.8583 14.6475C14.5583 12.5117 15.5925 10.4058 15.6625 8.53332C15.6902 7.77232 15.5642 7.01354 15.2921 6.30231C15.02 5.59108 14.6073 4.94199 14.0788 4.39381C13.5502 3.84564 12.9165 3.40963 12.2157 3.11183C11.5148 2.81402 10.7611 2.66054 9.99959 2.66054C9.23809 2.66054 8.48439 2.81402 7.78353 3.11183C7.08266 3.40963 6.44901 3.84564 5.92043 4.39381C5.39185 4.94199 4.97917 5.59108 4.70706 6.30231C4.43495 7.01354 4.30898 7.77232 4.33668 8.53332C4.40751 10.4058 5.44251 12.5117 7.14168 14.6475C7.94873 15.6592 8.83575 16.6045 9.79418 17.4742C9.8864 17.5575 9.95501 17.618 10 17.6558L10.2058 17.4742ZM9.38501 18.445C9.38501 18.445 3.33334 13.3483 3.33334 8.33332C3.33334 6.56521 4.03572 4.86952 5.28596 3.61928C6.53621 2.36904 8.2319 1.66666 10 1.66666C11.7681 1.66666 13.4638 2.36904 14.7141 3.61928C15.9643 4.86952 16.6667 6.56521 16.6667 8.33332C16.6667 13.3483 10.615 18.445 10.615 18.445C10.2783 18.755 9.72418 18.7517 9.38501 18.445ZM10 10.6667C10.6188 10.6667 11.2123 10.4208 11.6499 9.98324C12.0875 9.54565 12.3333 8.95216 12.3333 8.33332C12.3333 7.71449 12.0875 7.12099 11.6499 6.68341C11.2123 6.24582 10.6188 5.99999 10 5.99999C9.38117 5.99999 8.78768 6.24582 8.35009 6.68341C7.91251 7.12099 7.66668 7.71449 7.66668 8.33332C7.66668 8.95216 7.91251 9.54565 8.35009 9.98324C8.78768 10.4208 9.38117 10.6667 10 10.6667ZM10 11.6667C9.11595 11.6667 8.26811 11.3155 7.64299 10.6903C7.01787 10.0652 6.66668 9.21738 6.66668 8.33332C6.66668 7.44927 7.01787 6.60142 7.64299 5.9763C8.26811 5.35118 9.11595 4.99999 10 4.99999C10.8841 4.99999 11.7319 5.35118 12.357 5.9763C12.9822 6.60142 13.3333 7.44927 13.3333 8.33332C13.3333 9.21738 12.9822 10.0652 12.357 10.6903C11.7319 11.3155 10.8841 11.6667 10 11.6667Z"
			fill="#3F3F46"
		/>
	</svg>
);

export const PhoneSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.67124 1.70274C5.63331 0.694404 7.21753 0.87357 8.02308 2.00857L9.02073 3.4119C9.67687 4.33524 9.61837 5.62524 8.8397 6.44107L8.65155 6.6394C8.63022 6.72266 8.62805 6.81008 8.64523 6.8944C8.69503 7.2344 8.9646 7.9544 10.0935 9.13774C11.2224 10.3211 11.9101 10.6044 12.2374 10.6577C12.3199 10.6752 12.405 10.6727 12.4864 10.6502L12.809 10.3119C13.5015 9.5869 14.5639 9.45107 15.4209 9.9419L16.9308 10.8086C18.2249 11.5486 18.5514 13.4019 17.4921 14.5127L16.3687 15.6894C16.0146 16.0602 15.5387 16.3694 14.9584 16.4269C13.5275 16.5677 10.1939 16.3877 6.68946 12.7152C3.41904 9.2869 2.79136 6.2969 2.71151 4.82357C2.67199 4.07857 3.00559 3.44857 3.43089 3.00357L4.67124 1.70274ZM7.07445 2.75774C6.67365 2.19357 5.92739 2.14857 5.50683 2.5894L4.26569 3.8894C4.00482 4.16274 3.87991 4.4644 3.89573 4.75274C3.95897 5.92357 4.46491 8.62107 7.52584 11.8294C10.737 15.1944 13.7023 15.2952 14.8485 15.1819C15.0825 15.1594 15.3149 15.0311 15.5323 14.8036L16.6549 13.6261C17.1118 13.1477 17.0114 12.2761 16.3648 11.9061L14.8548 11.0402C14.4374 10.8019 13.9489 10.8802 13.6453 11.1986L13.2856 11.5761L12.8667 11.1327C13.2856 11.5761 13.2849 11.5769 13.2841 11.5769L13.2833 11.5786L13.2809 11.5811L13.2754 11.5861L13.2635 11.5977C13.2301 11.6304 13.1942 11.6599 13.156 11.6861C13.0928 11.7302 13.009 11.7794 12.9038 11.8202C12.6904 11.9044 12.4074 11.9494 12.0579 11.8927C11.3726 11.7819 10.4642 11.2894 9.2571 10.0244C8.05075 8.7594 7.5796 7.80774 7.47366 7.08607C7.41912 6.71774 7.4626 6.4194 7.54323 6.1944C7.58761 6.06779 7.65115 5.9496 7.73138 5.8444L7.75667 5.81524L7.76774 5.80274L7.77249 5.79774L7.77486 5.79524L7.77644 5.79357L8.00411 5.55524C8.34246 5.1994 8.38989 4.61024 8.07131 4.16107L7.07445 2.75774Z"
			fill="#3F3F46"
		/>
	</svg>
);

export const DotSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="4"
		height="4"
		viewBox="0 0 4 4"
		fill="none"
	>
		<circle cx="2" cy="2" r="2" fill="#3F3F46" />
	</svg>
);

export const EatSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
	>
		<path
			d="M4.67 2.00002C4.046 2.00002 3.495 2.43802 3.38 3.06802C3.232 3.88602 3 5.34202 3 6.50002C3 7.73102 3.636 8.81302 4.595 9.43602C4.866 9.61302 5 9.84102 5 10.036V10.446C5 10.464 4.999 10.482 4.997 10.5C4.97 10.76 4.846 11.929 4.729 13.131C4.614 14.316 4.5 15.581 4.5 16C4.5 16.5304 4.71071 17.0392 5.08579 17.4142C5.46086 17.7893 5.96957 18 6.5 18C7.03043 18 7.53914 17.7893 7.91421 17.4142C8.28929 17.0392 8.5 16.5304 8.5 16C8.5 15.58 8.386 14.316 8.271 13.131C8.1855 12.254 8.09617 11.3773 8.003 10.501L8 10.446V10.036C8 9.84002 8.134 9.61202 8.405 9.43602C8.89455 9.1184 9.29691 8.68341 9.57547 8.17064C9.85404 7.65786 9.99998 7.08357 10 6.50002C10 5.34202 9.768 3.88602 9.62 3.06802C9.5644 2.76696 9.40473 2.49503 9.16891 2.29979C8.9331 2.10456 8.63614 1.99845 8.33 2.00002C7.99 2.00002 7.68 2.12702 7.446 2.33602C7.17862 2.11869 6.84457 2.00004 6.5 2.00002C6.141 2.00002 5.812 2.12602 5.554 2.33602C5.3112 2.11891 4.99571 1.99924 4.67 2.00002ZM6 3.50002C6 3.36741 6.05268 3.24023 6.14645 3.14646C6.24021 3.0527 6.36739 3.00002 6.5 3.00002C6.63261 3.00002 6.75979 3.0527 6.85355 3.14646C6.94732 3.24023 7 3.36741 7 3.50002V6.50002C7 6.63263 7.05268 6.7598 7.14645 6.85357C7.24021 6.94734 7.36739 7.00002 7.5 7.00002C7.63261 7.00002 7.75979 6.94734 7.85355 6.85357C7.94732 6.7598 8 6.63263 8 6.50002V3.33002C8 3.28668 8.00854 3.24377 8.02512 3.20373C8.0417 3.16369 8.06601 3.12732 8.09665 3.09667C8.1273 3.06603 8.16368 3.04172 8.20371 3.02514C8.24375 3.00855 8.28666 3.00002 8.33 3.00002C8.487 3.00002 8.61 3.10802 8.636 3.24702C8.783 4.06002 9 5.43902 9 6.50002C9.00005 6.91705 8.89577 7.32748 8.69666 7.69391C8.49755 8.06035 8.20993 8.37115 7.86 8.59802C7.421 8.88302 7 9.38402 7 10.036V10.446C7 10.4994 7.00267 10.5527 7.008 10.606C7.036 10.864 7.159 12.03 7.276 13.228C7.394 14.443 7.5 15.643 7.5 16C7.5 16.2652 7.39464 16.5196 7.20711 16.7071C7.01957 16.8947 6.76522 17 6.5 17C6.23478 17 5.98043 16.8947 5.79289 16.7071C5.60536 16.5196 5.5 16.2652 5.5 16C5.5 15.643 5.606 14.443 5.724 13.228C5.841 12.03 5.964 10.864 5.992 10.606C5.99733 10.5527 6 10.4994 6 10.446V10.036C6 9.38402 5.579 8.88302 5.14 8.59802C4.79007 8.37115 4.50245 8.06035 4.30334 7.69391C4.10423 7.32748 3.99995 6.91705 4 6.50002C4 5.44002 4.217 4.06002 4.364 3.24702C4.3777 3.17619 4.41605 3.11251 4.47226 3.06729C4.52847 3.02207 4.59888 2.99823 4.671 3.00002C4.75835 3.00028 4.84203 3.03517 4.9037 3.09702C4.96537 3.15888 5 3.24267 5 3.33002V6.50002C5 6.63263 5.05268 6.7598 5.14645 6.85357C5.24021 6.94734 5.36739 7.00002 5.5 7.00002C5.63261 7.00002 5.75979 6.94734 5.85355 6.85357C5.94732 6.7598 6 6.63263 6 6.50002V3.50002ZM11 6.50002C11 5.30654 11.4741 4.16195 12.318 3.31804C13.1619 2.47412 14.3065 2.00002 15.5 2.00002C15.6326 2.00002 15.7598 2.0527 15.8536 2.14646C15.9473 2.24023 16 2.36741 16 2.50002V9.47802L16.02 9.70202C16.0979 10.6005 16.1739 11.4992 16.248 12.398C16.372 13.905 16.5 15.559 16.5 16C16.5 16.5304 16.2893 17.0392 15.9142 17.4142C15.5391 17.7893 15.0304 18 14.5 18C13.9696 18 13.4609 17.7893 13.0858 17.4142C12.7107 17.0392 12.5 16.5304 12.5 16C12.5 15.56 12.628 13.905 12.752 12.398C12.814 11.637 12.877 10.901 12.924 10.356L12.954 10H12.5C12.1022 10 11.7206 9.84198 11.4393 9.56068C11.158 9.27937 11 8.89784 11 8.50002V6.50002ZM13.998 9.54402L13.977 9.78902L13.92 10.442C13.873 10.986 13.81 11.72 13.748 12.48C13.622 14.017 13.5 15.612 13.5 16C13.5 16.2652 13.6054 16.5196 13.7929 16.7071C13.9804 16.8947 14.2348 17 14.5 17C14.7652 17 15.0196 16.8947 15.2071 16.7071C15.3946 16.5196 15.5 16.2652 15.5 16C15.5 15.612 15.378 14.017 15.252 12.48C15.1778 11.5828 15.1015 10.6858 15.023 9.78902L15.002 9.54502V9.54402L15 9.50002V3.03502C14.1669 3.15527 13.4049 3.57177 12.854 4.20817C12.303 4.84457 11.9998 5.65823 12 6.50002V8.50002C12 8.63263 12.0527 8.7598 12.1464 8.85357C12.2402 8.94734 12.3674 9.00002 12.5 9.00002H13.5C13.5694 9.00003 13.638 9.01447 13.7015 9.04242C13.7649 9.07038 13.8219 9.11124 13.8687 9.1624C13.9156 9.21356 13.9513 9.27391 13.9735 9.33961C13.9958 9.40531 14.0041 9.47492 13.998 9.54402Z"
			fill="#3F3F46"
		/>
	</svg>
);

export const TimeSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
	>
		<path
			d="M2.5 10C2.5 10.9849 2.69399 11.9602 3.0709 12.8701C3.44781 13.7801 4.00026 14.6069 4.6967 15.3033C5.39314 15.9997 6.21993 16.5522 7.12987 16.9291C8.03982 17.306 9.01509 17.5 10 17.5C10.9849 17.5 11.9602 17.306 12.8701 16.9291C13.7801 16.5522 14.6069 15.9997 15.3033 15.3033C15.9997 14.6069 16.5522 13.7801 16.9291 12.8701C17.306 11.9602 17.5 10.9849 17.5 10C17.5 8.01088 16.7098 6.10322 15.3033 4.6967C13.8968 3.29018 11.9891 2.5 10 2.5C8.01088 2.5 6.10322 3.29018 4.6967 4.6967C3.29018 6.10322 2.5 8.01088 2.5 10Z"
			stroke="#3F3F46"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M10 5.83337V10L12.5 12.5"
			stroke="#3F3F46"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const LinkSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		viewBox="0 -3 20 20"
		fill="none"
	>
		<path
			d="M7.02525 1.6875H7.05C7.19918 1.6875 7.34226 1.74676 7.44775 1.85225C7.55324 1.95774 7.6125 2.10082 7.6125 2.25C7.6125 2.39918 7.55324 2.54226 7.44775 2.64775C7.34226 2.75324 7.19918 2.8125 7.05 2.8125C6.201 2.8125 5.59725 2.8125 5.1255 2.8515C4.6605 2.889 4.37175 2.96175 4.143 3.078C3.68447 3.31167 3.31167 3.68447 3.078 4.143C2.96175 4.37175 2.88975 4.6605 2.8515 5.1255C2.81325 5.598 2.8125 6.201 2.8125 7.05V10.95C2.8125 11.7998 2.8125 12.4028 2.8515 12.8745C2.889 13.3395 2.96175 13.6283 3.078 13.857C3.31167 14.3155 3.68447 14.6883 4.143 14.922C4.37175 15.0382 4.6605 15.1102 5.1255 15.1485C5.598 15.1868 6.201 15.1875 7.05 15.1875H10.95C11.7998 15.1875 12.4028 15.1875 12.8745 15.1485C13.3395 15.111 13.6283 15.0382 13.857 14.922C14.3155 14.6883 14.6883 14.3155 14.922 13.857C15.0382 13.6283 15.1102 13.3395 15.1485 12.8745C15.1868 12.402 15.1875 11.799 15.1875 10.95V10.125C15.1875 9.97582 15.2468 9.83274 15.3523 9.72725C15.4577 9.62176 15.6008 9.5625 15.75 9.5625C15.8992 9.5625 16.0423 9.62176 16.1477 9.72725C16.2532 9.83274 16.3125 9.97582 16.3125 10.125V10.9748C16.3125 11.7938 16.3125 12.4432 16.2698 12.966C16.2263 13.5015 16.1347 13.9537 15.9247 14.3678C15.5831 15.0379 15.038 15.5826 14.3678 15.924C13.9537 16.1348 13.5015 16.2263 12.966 16.2698C12.4432 16.3125 11.7938 16.3125 10.9748 16.3125H7.02525C6.20625 16.3125 5.55675 16.3125 5.034 16.2698C4.4985 16.2263 4.04625 16.1347 3.633 15.9247C2.9626 15.5832 2.41756 15.0381 2.076 14.3678C1.86525 13.9537 1.77375 13.5015 1.73025 12.966C1.6875 12.4432 1.6875 11.7938 1.6875 10.9748V7.02525C1.6875 6.20625 1.6875 5.55675 1.73025 5.034C1.77375 4.4985 1.86525 4.04625 2.07525 3.633C2.41701 2.96249 2.96233 2.41743 3.633 2.076C4.0455 1.86525 4.4985 1.77375 5.034 1.73025C5.55675 1.6875 6.20625 1.6875 7.02525 1.6875ZM10.125 2.25C10.125 2.10082 10.1843 1.95774 10.2898 1.85225C10.3952 1.74676 10.5383 1.6875 10.6875 1.6875H15.75C15.8992 1.6875 16.0423 1.74676 16.1477 1.85225C16.2532 1.95774 16.3125 2.10082 16.3125 2.25V7.3125C16.3125 7.46168 16.2532 7.60476 16.1477 7.71025C16.0423 7.81574 15.8992 7.875 15.75 7.875C15.6008 7.875 15.4577 7.81574 15.3523 7.71025C15.2468 7.60476 15.1875 7.46168 15.1875 7.3125V3.6075L9.96 8.835C9.9085 8.89026 9.8464 8.93459 9.7774 8.96534C9.7084 8.99608 9.63392 9.01261 9.55839 9.01394C9.48286 9.01528 9.40784 9.00138 9.3378 8.97309C9.26776 8.9448 9.20414 8.90269 9.15072 8.84928C9.09731 8.79586 9.0552 8.73224 9.02691 8.6622C8.99862 8.59216 8.98472 8.51714 8.98606 8.44161C8.98739 8.36608 9.00392 8.2916 9.03466 8.2226C9.06541 8.1536 9.10974 8.0915 9.165 8.04L14.3925 2.8125H10.6875C10.5383 2.8125 10.3952 2.75324 10.2898 2.64775C10.1843 2.54226 10.125 2.39918 10.125 2.25Z"
			fill="#3F3F46"
		/>
	</svg>
);

export const OutletFilterSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
	>
		<path
			d="M2.25 3.375L7.65 9.68175V14.4165L10.35 15.75V9.68175L15.75 3.375H2.25Z"
			stroke="#3F3F46"
			strokeWidth="1.2"
			strokeLinejoin="round"
		/>
	</svg>
);

export const SearchSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
	>
		<path
			d="M15.75 15.75L12.4928 12.4928M12.4928 12.4928C13.0499 11.9356 13.4919 11.2742 13.7934 10.5462C14.095 9.81822 14.2502 9.03798 14.2502 8.25003C14.2502 7.46208 14.095 6.68184 13.7934 5.95387C13.4919 5.2259 13.0499 4.56445 12.4928 4.00728C11.9356 3.45012 11.2741 3.00815 10.5462 2.70661C9.81819 2.40508 9.03795 2.24988 8.25 2.24988C7.46205 2.24988 6.68181 2.40508 5.95384 2.70661C5.22587 3.00815 4.56442 3.45012 4.00725 4.00728C2.882 5.13253 2.24985 6.65869 2.24985 8.25003C2.24985 9.84137 2.882 11.3675 4.00725 12.4928C5.1325 13.618 6.65866 14.2502 8.25 14.2502C9.84134 14.2502 11.3675 13.618 12.4928 12.4928Z"
			stroke="#71717A"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const EllipsisSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="9"
		height="8"
		viewBox="0 0 9 8"
		fill="none"
	>
		<circle cx="4.5" cy="4" r="4" fill="#0E49B5" />
	</svg>
);

export const IncreaseArrowSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="10"
		height="10"
		viewBox="0 0 10 10"
		fill="none"
	>
		<g clipPath="url(#clip0_1484_35259)">
			<path
				d="M6.78613 2.5H9.64328V5.35714"
				stroke="#16A34A"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.64313 2.5L5.60742 6.53571C5.54066 6.60115 5.4509 6.63781 5.35742 6.63781C5.26394 6.63781 5.17418 6.60115 5.10742 6.53571L3.46456 4.89286C3.3978 4.82742 3.30805 4.79077 3.21456 4.79077C3.12108 4.79077 3.03132 4.82742 2.96456 4.89286L0.357422 7.5"
				stroke="#16A34A"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1484_35259">
				<rect width="10" height="10" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

export const EqualSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="10"
		height="10"
		viewBox="0 0 10 10"
		fill="none"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.49967 3.3335C2.38917 3.3335 2.28319 3.37739 2.20505 3.45554C2.12691 3.53368 2.08301 3.63966 2.08301 3.75016C2.08301 3.86067 2.12691 3.96665 2.20505 4.04479C2.28319 4.12293 2.38917 4.16683 2.49967 4.16683H7.49967C7.61018 4.16683 7.71616 4.12293 7.7943 4.04479C7.87244 3.96665 7.91634 3.86067 7.91634 3.75016C7.91634 3.63966 7.87244 3.53368 7.7943 3.45554C7.71616 3.37739 7.61018 3.3335 7.49967 3.3335H2.49967ZM2.49967 5.8335C2.38917 5.8335 2.28319 5.87739 2.20505 5.95553C2.12691 6.03368 2.08301 6.13966 2.08301 6.25016C2.08301 6.36067 2.12691 6.46665 2.20505 6.54479C2.28319 6.62293 2.38917 6.66683 2.49967 6.66683H7.49967C7.61018 6.66683 7.71616 6.62293 7.7943 6.54479C7.87244 6.46665 7.91634 6.36067 7.91634 6.25016C7.91634 6.13966 7.87244 6.03368 7.7943 5.95553C7.71616 5.87739 7.61018 5.8335 7.49967 5.8335H2.49967Z"
			fill="#27272A"
		/>
	</svg>
);

export const DecreaseArrowSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="10"
		height="10"
		viewBox="0 0 10 10"
		fill="none"
	>
		<g clipPath="url(#clip0_1653_34428)">
			<path
				d="M6.78613 7.50021H9.64328V4.64307"
				stroke="#D03238"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.64314 7.5L5.60742 3.46429C5.54066 3.39885 5.45091 3.36219 5.35742 3.36219C5.26394 3.36219 5.17418 3.39885 5.10742 3.46429L3.46456 5.10714C3.3978 5.17258 3.30805 5.20923 3.21456 5.20923C3.12108 5.20923 3.03133 5.17258 2.96456 5.10714L0.357422 2.5"
				stroke="#D03238"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1653_34428">
				<rect width="10" height="10" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

export const ExportSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
	>
		<path
			d="M15.1875 7.87544V14.6254C15.1875 14.9238 15.069 15.21 14.858 15.4209C14.647 15.6319 14.3609 15.7504 14.0625 15.7504H3.9375C3.63913 15.7504 3.35298 15.6319 3.142 15.4209C2.93103 15.21 2.8125 14.9238 2.8125 14.6254V7.87544C2.8125 7.57707 2.93103 7.29093 3.142 7.07995C3.35298 6.86897 3.63913 6.75044 3.9375 6.75044H5.625C5.77418 6.75044 5.91726 6.80971 6.02275 6.91519C6.12824 7.02068 6.1875 7.16376 6.1875 7.31294C6.1875 7.46213 6.12824 7.6052 6.02275 7.71069C5.91726 7.81618 5.77418 7.87544 5.625 7.87544H3.9375V14.6254H14.0625V7.87544H12.375C12.2258 7.87544 12.0827 7.81618 11.9773 7.71069C11.8718 7.6052 11.8125 7.46213 11.8125 7.31294C11.8125 7.16376 11.8718 7.02068 11.9773 6.91519C12.0827 6.80971 12.2258 6.75044 12.375 6.75044H14.0625C14.3609 6.75044 14.647 6.86897 14.858 7.07995C15.069 7.29093 15.1875 7.57707 15.1875 7.87544ZM6.58547 4.89841L8.4375 3.04568V9.56294C8.4375 9.71213 8.49676 9.8552 8.60225 9.96069C8.70774 10.0662 8.85082 10.1254 9 10.1254C9.14918 10.1254 9.29226 10.0662 9.39775 9.96069C9.50324 9.8552 9.5625 9.71213 9.5625 9.56294V3.04568L11.4145 4.89841C11.5201 5.00396 11.6632 5.06326 11.8125 5.06326C11.9618 5.06326 12.1049 5.00396 12.2105 4.89841C12.316 4.79286 12.3753 4.64971 12.3753 4.50044C12.3753 4.35118 12.316 4.20802 12.2105 4.10247L9.39797 1.28997C9.34573 1.23767 9.28369 1.19619 9.2154 1.16788C9.14712 1.13957 9.07392 1.125 9 1.125C8.92608 1.125 8.85288 1.13957 8.7846 1.16788C8.71631 1.19619 8.65427 1.23767 8.60203 1.28997L5.78953 4.10247C5.68398 4.20802 5.62469 4.35118 5.62469 4.50044C5.62469 4.64971 5.68398 4.79286 5.78953 4.89841C5.89508 5.00396 6.03823 5.06326 6.1875 5.06326C6.33677 5.06326 6.47992 5.00396 6.58547 4.89841Z"
			fill="currentColor"
		/>
	</svg>
);

export const CollapseSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		viewBox="0 -1 16 16"
		fill="none"
	>
		<mask id="path-1-inside-1_651_9169" fill="white">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.14088 3.57992C1.99936 3.44337 1.80987 3.36786 1.61323 3.36966C1.41658 3.37146 1.2285 3.45043 1.08951 3.58955C0.950522 3.72867 0.871734 3.91682 0.870119 4.11347C0.868503 4.31012 0.94419 4.49953 1.08088 4.64092L4.43888 7.99992L1.08588 11.3539C1.01219 11.4226 0.953087 11.5054 0.912095 11.5974C0.871103 11.6894 0.849061 11.7887 0.847285 11.8894C0.845508 11.9901 0.864033 12.0901 0.901754 12.1835C0.939475 12.2769 0.995619 12.3617 1.06684 12.433C1.13806 12.5042 1.22289 12.5603 1.31628 12.598C1.40967 12.6358 1.5097 12.6543 1.6104 12.6525C1.7111 12.6507 1.81042 12.6287 1.90241 12.5877C1.99441 12.5467 2.07721 12.4876 2.14588 12.4139L6.02988 8.52992C6.17033 8.3893 6.24922 8.19867 6.24922 7.99992C6.24922 7.80117 6.17033 7.61055 6.02988 7.46992L2.14088 3.57992ZM13.8589 12.4199C14.0004 12.5565 14.1899 12.632 14.3865 12.6302C14.5832 12.6284 14.7712 12.5494 14.9102 12.4103C15.0492 12.2712 15.128 12.083 15.1296 11.8864C15.1312 11.6897 15.0556 11.5003 14.9189 11.3589L11.5609 7.99992L14.9139 4.64592C15.0464 4.50375 15.1185 4.3157 15.1151 4.1214C15.1116 3.9271 15.0329 3.74171 14.8955 3.6043C14.7581 3.46689 14.5727 3.38817 14.3784 3.38475C14.1841 3.38132 13.9961 3.45344 13.8539 3.58592L9.96988 7.46992C9.82943 7.61055 9.75054 7.80117 9.75054 7.99992C9.75054 8.19867 9.82943 8.3893 9.96988 8.52992L13.8589 12.4199Z"
			/>
		</mask>
		<path
			d="M2.14088 3.57992L3.27239 2.4487L3.26223 2.43853L3.25188 2.42854L2.14088 3.57992ZM1.08088 4.64092L-0.0694536 5.75301L-0.0601384 5.76264L-0.0506631 5.77212L1.08088 4.64092ZM4.43888 7.99992L5.57042 9.13112L6.70128 7.99992L5.57042 6.86872L4.43888 7.99992ZM1.08588 11.3539L2.17663 12.5245L2.19737 12.5052L2.21742 12.4851L1.08588 11.3539ZM2.14588 12.4139L1.01451 11.2825L0.994544 11.3025L0.975298 11.3232L2.14588 12.4139ZM6.02988 8.52992L7.16125 9.66129L7.16195 9.66059L6.02988 8.52992ZM6.02988 7.46992L7.16195 6.33925L7.16139 6.3387L6.02988 7.46992ZM13.8589 12.4199L12.7274 13.5511L12.7375 13.5613L12.7479 13.5713L13.8589 12.4199ZM14.9189 11.3589L16.0692 10.2468L16.0599 10.2372L16.0504 10.2277L14.9189 11.3589ZM11.5609 7.99992L10.4293 6.86872L9.29847 7.99992L10.4293 9.13112L11.5609 7.99992ZM14.9139 4.64592L16.0454 5.77712L16.0653 5.75724L16.0845 5.73668L14.9139 4.64592ZM13.8539 3.58592L12.7631 2.41534L12.7425 2.43459L12.7225 2.45455L13.8539 3.58592ZM9.96988 7.46992L8.83851 6.33855L8.8378 6.33925L9.96988 7.46992ZM9.75054 7.99992H8.15054H9.75054ZM9.96988 8.52992L8.8378 9.66059L8.83836 9.66115L9.96988 8.52992ZM2.14088 3.57992L3.25188 2.42854C2.80846 2.00068 2.21474 1.76408 1.59857 1.76973L1.61323 3.36966L1.62788 4.96959C1.40501 4.97163 1.19026 4.88606 1.02987 4.7313L2.14088 3.57992ZM1.61323 3.36966L1.59857 1.76973C0.98241 1.77537 0.393114 2.0228 -0.0423908 2.45871L1.08951 3.58955L2.22142 4.72039C2.06389 4.87806 1.85075 4.96755 1.62788 4.96959L1.61323 3.36966ZM1.08951 3.58955L-0.0423908 2.45871C-0.477896 2.89463 -0.724766 3.48416 -0.729827 4.10032L0.870119 4.11347L2.47006 4.12661C2.46823 4.34948 2.37894 4.56271 2.22142 4.72039L1.08951 3.58955ZM0.870119 4.11347L-0.729827 4.10032C-0.734889 4.71649 -0.497738 5.31 -0.0694536 5.75301L1.08088 4.64092L2.23121 3.52883C2.38612 3.68907 2.4719 3.90374 2.47006 4.12661L0.870119 4.11347ZM1.08088 4.64092L-0.0506631 5.77212L3.30734 9.13112L4.43888 7.99992L5.57042 6.86872L2.21242 3.50972L1.08088 4.64092ZM4.43888 7.99992L3.30734 6.86872L-0.0456633 10.2227L1.08588 11.3539L2.21742 12.4851L5.57042 9.13112L4.43888 7.99992ZM1.08588 11.3539L-0.00487942 10.1833C-0.235764 10.3985 -0.420951 10.6579 -0.549393 10.9462L0.912095 11.5974L2.37358 12.2486C2.32713 12.3528 2.26014 12.4467 2.17663 12.5245L1.08588 11.3539ZM0.912095 11.5974L-0.549393 10.9462C-0.677835 11.2345 -0.746899 11.5456 -0.752466 11.8612L0.847285 11.8894L2.44704 11.9176C2.44502 12.0318 2.42004 12.1443 2.37358 12.2486L0.912095 11.5974ZM0.847285 11.8894L-0.752466 11.8612C-0.758034 12.1767 -0.699989 12.4901 -0.581797 12.7827L0.901754 12.1835L2.3853 11.5843C2.42805 11.6901 2.44905 11.8035 2.44704 11.9176L0.847285 11.8894ZM0.901754 12.1835L-0.581797 12.7827C-0.463606 13.0754 -0.287687 13.3412 -0.0645329 13.5643L1.06684 12.433L2.19821 11.3016C2.27893 11.3823 2.34255 11.4784 2.3853 11.5843L0.901754 12.1835ZM1.06684 12.433L-0.0645329 13.5643C0.158622 13.7875 0.424436 13.9634 0.717048 14.0816L1.31628 12.598L1.91551 11.1145C2.02135 11.1572 2.11749 11.2209 2.19821 11.3016L1.06684 12.433ZM1.31628 12.598L0.717048 14.0816C1.00966 14.1998 1.32309 14.2578 1.63862 14.2523L1.6104 12.6525L1.58217 11.0528C1.69631 11.0507 1.80967 11.0717 1.91551 11.1145L1.31628 12.598ZM1.6104 12.6525L1.63862 14.2523C1.95416 14.2467 2.26534 14.1776 2.55361 14.0492L1.90241 12.5877L1.25122 11.1262C1.35549 11.0798 1.46804 11.0548 1.58217 11.0528L1.6104 12.6525ZM1.90241 12.5877L2.55361 14.0492C2.84188 13.9207 3.10132 13.7356 3.31645 13.5047L2.14588 12.4139L0.975298 11.3232C1.05311 11.2397 1.14695 11.1727 1.25122 11.1262L1.90241 12.5877ZM2.14588 12.4139L3.27725 13.5453L7.16125 9.66129L6.02988 8.52992L4.89851 7.39855L1.01451 11.2825L2.14588 12.4139ZM6.02988 8.52992L7.16195 9.66059C7.60203 9.21996 7.84922 8.62267 7.84922 7.99992H6.24922H4.64922C4.64922 7.77467 4.73862 7.55863 4.8978 7.39925L6.02988 8.52992ZM6.24922 7.99992H7.84922C7.84922 7.37717 7.60203 6.77988 7.16195 6.33925L6.02988 7.46992L4.8978 8.60059C4.73862 8.44121 4.64922 8.22517 4.64922 7.99992H6.24922ZM6.02988 7.46992L7.16139 6.3387L3.27239 2.4487L2.14088 3.57992L1.00936 4.71115L4.89836 8.60115L6.02988 7.46992ZM13.8589 12.4199L12.7479 13.5713C13.1913 13.9992 13.785 14.2358 14.4012 14.2301L14.3865 12.6302L14.3719 11.0302C14.5947 11.0282 14.8095 11.1138 14.9699 11.2685L13.8589 12.4199ZM14.3865 12.6302L14.4012 14.2301C15.0173 14.2245 15.6066 13.977 16.0421 13.5411L14.9102 12.4103L13.7783 11.2795C13.9359 11.1218 14.149 11.0323 14.3719 11.0302L14.3865 12.6302ZM14.9102 12.4103L16.0421 13.5411C16.4776 13.1052 16.7245 12.5157 16.7296 11.8995L15.1296 11.8864L13.5297 11.8732C13.5315 11.6504 13.6208 11.4371 13.7783 11.2795L14.9102 12.4103ZM15.1296 11.8864L16.7296 11.8995C16.7346 11.2833 16.4975 10.6898 16.0692 10.2468L14.9189 11.3589L13.7685 12.471C13.6136 12.3108 13.5279 12.0961 13.5297 11.8732L15.1296 11.8864ZM14.9189 11.3589L16.0504 10.2277L12.6924 6.86872L11.5609 7.99992L10.4293 9.13112L13.7873 12.4901L14.9189 11.3589ZM11.5609 7.99992L12.6924 9.13112L16.0454 5.77712L14.9139 4.64592L13.7823 3.51472L10.4293 6.86872L11.5609 7.99992ZM14.9139 4.64592L16.0845 5.73668C16.4996 5.2912 16.7255 4.70199 16.7148 4.09317L15.1151 4.1214L13.5153 4.14962C13.5114 3.92941 13.5932 3.71629 13.7433 3.55516L14.9139 4.64592ZM15.1151 4.1214L16.7148 4.09317C16.7041 3.48436 16.4574 2.90349 16.0269 2.47293L14.8955 3.6043L13.7641 4.73567C13.6084 4.57993 13.5192 4.36983 13.5153 4.14962L15.1151 4.1214ZM14.8955 3.6043L16.0269 2.47293C15.5963 2.04237 15.0154 1.79574 14.4066 1.78499L14.3784 3.38475L14.3502 4.9845C14.13 4.98061 13.9199 4.8914 13.7641 4.73567L14.8955 3.6043ZM14.3784 3.38475L14.4066 1.78499C13.7978 1.77425 13.2086 2.00024 12.7631 2.41534L13.8539 3.58592L14.9446 4.7565C14.7835 4.90664 14.5704 4.98838 14.3502 4.9845L14.3784 3.38475ZM13.8539 3.58592L12.7225 2.45455L8.83851 6.33855L9.96988 7.46992L11.1012 8.60129L14.9852 4.71729L13.8539 3.58592ZM9.96988 7.46992L8.8378 6.33925C8.39772 6.77988 8.15054 7.37717 8.15054 7.99992H9.75054H11.3505C11.3505 8.22517 11.2611 8.44121 11.102 8.60059L9.96988 7.46992ZM9.75054 7.99992H8.15054C8.15054 8.62267 8.39773 9.21996 8.8378 9.66059L9.96988 8.52992L11.102 7.39925C11.2611 7.55863 11.3505 7.77467 11.3505 7.99992H9.75054ZM9.96988 8.52992L8.83836 9.66115L12.7274 13.5511L13.8589 12.4199L14.9904 11.2887L11.1014 7.39869L9.96988 8.52992Z"
			fill="black"
			fillOpacity="0.75"
			mask="url(#path-1-inside-1_651_9169)"
		/>
	</svg>
);

export const ExpandSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="10"
		viewBox="0 0 16 10"
		fill="none"
	>
		<mask id="path-1-inside-1_651_3768" fill="white">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M11.8912 0.581829C11.7497 0.445276 11.5602 0.369768 11.3635 0.371569C11.1669 0.37337 10.9788 0.452336 10.8398 0.591458C10.7008 0.73058 10.622 0.918727 10.6204 1.11538C10.6188 1.31203 10.6945 1.50144 10.8312 1.64283L14.1892 5.00183L10.8362 8.35583C10.7037 8.498 10.6316 8.68605 10.635 8.88035C10.6384 9.07465 10.7171 9.26004 10.8545 9.39745C10.992 9.53486 11.1773 9.61358 11.3716 9.617C11.566 9.62043 11.754 9.54831 11.8962 9.41583L15.7802 5.53183C15.9206 5.3912 15.9995 5.20058 15.9995 5.00183C15.9995 4.80308 15.9206 4.61245 15.7802 4.47183L11.8912 0.581829ZM4.10917 9.42183C4.17839 9.49343 4.26118 9.55053 4.3527 9.58979C4.44422 9.62905 4.54264 9.64969 4.64223 9.65051C4.74181 9.65133 4.84056 9.63231 4.93272 9.59455C5.02487 9.5568 5.10858 9.50107 5.17897 9.43062C5.24935 9.36016 5.30501 9.2764 5.34267 9.18421C5.38034 9.09202 5.39927 8.99325 5.39836 8.89367C5.39745 8.79409 5.37671 8.69568 5.33736 8.6042C5.29801 8.51271 5.24084 8.42998 5.16917 8.36083L1.81117 5.00083L5.16417 1.64783C5.23786 1.57917 5.29696 1.49637 5.33795 1.40437C5.37894 1.31237 5.40099 1.21305 5.40276 1.11235C5.40454 1.01165 5.38601 0.91162 5.34829 0.818232C5.31057 0.724844 5.25443 0.64001 5.18321 0.568791C5.11199 0.497572 5.02716 0.441428 4.93377 0.403707C4.84038 0.365986 4.74035 0.347461 4.63965 0.349238C4.53895 0.351015 4.43963 0.373056 4.34763 0.414048C4.25563 0.45504 4.17283 0.514142 4.10417 0.587829L0.220172 4.47183C0.0797215 4.61245 0.000831604 4.80308 0.000831604 5.00183C0.000831604 5.20058 0.0797215 5.3912 0.220172 5.53183L4.10917 9.42183Z"
			/>
		</mask>
		<path
			d="M11.8912 0.581829L13.0227 -0.549396L13.0125 -0.559565L13.0022 -0.569549L11.8912 0.581829ZM10.8312 1.64283L9.68084 2.75492L9.69016 2.76455L9.69963 2.77403L10.8312 1.64283ZM14.1892 5.00183L15.3207 6.13303L16.4516 5.00183L15.3207 3.87063L14.1892 5.00183ZM10.8362 8.35583L9.70463 7.22463L9.68476 7.24451L9.66559 7.26507L10.8362 8.35583ZM11.8962 9.41583L12.9869 10.5864L13.0076 10.5672L13.0275 10.5472L11.8962 9.41583ZM15.7802 5.53183L16.9115 6.6632L16.9122 6.6625L15.7802 5.53183ZM15.9995 5.00183H14.3995H15.9995ZM15.7802 4.47183L16.9122 3.34116L16.9117 3.3406L15.7802 4.47183ZM4.10917 9.42183L5.2595 8.30974L5.25018 8.30009L5.24069 8.2906L4.10917 9.42183ZM5.16917 8.36083L4.03746 9.49186L4.04772 9.50213L4.05817 9.51221L5.16917 8.36083ZM1.81117 5.00083L0.679801 3.86946L-0.451233 5.00049L0.679463 6.13186L1.81117 5.00083ZM5.16417 1.64783L4.07342 0.477251L4.05276 0.496497L4.0328 0.516458L5.16417 1.64783ZM4.10417 0.587829L5.23554 1.7192L5.2555 1.69924L5.27475 1.67858L4.10417 0.587829ZM0.220172 4.47183L-0.9112 3.34046L-0.911903 3.34116L0.220172 4.47183ZM0.220172 5.53183L-0.911903 6.6625L-0.911345 6.66305L0.220172 5.53183ZM11.8912 0.581829L13.0022 -0.569549C12.5588 -0.997415 11.965 -1.23401 11.3489 -1.22836L11.3635 0.371569L11.3782 1.9715C11.1553 1.97354 10.9406 1.88797 10.7802 1.73321L11.8912 0.581829ZM11.3635 0.371569L11.3489 -1.22836C10.7327 -1.22272 10.1434 -0.975296 9.7079 -0.53938L10.8398 0.591458L11.9717 1.7223C11.8142 1.87997 11.601 1.96946 11.3782 1.9715L11.3635 0.371569ZM10.8398 0.591458L9.7079 -0.53938C9.2724 -0.103462 9.02553 0.486068 9.02047 1.10223L10.6204 1.11538L12.2204 1.12852C12.2185 1.35139 12.1292 1.56462 11.9717 1.7223L10.8398 0.591458ZM10.6204 1.11538L9.02047 1.10223C9.01541 1.7184 9.25256 2.3119 9.68084 2.75492L10.8312 1.64283L11.9815 0.53074C12.1364 0.69098 12.2222 0.905653 12.2204 1.12852L10.6204 1.11538ZM10.8312 1.64283L9.69963 2.77403L13.0576 6.13303L14.1892 5.00183L15.3207 3.87063L11.9627 0.511627L10.8312 1.64283ZM14.1892 5.00183L13.0576 3.87063L9.70463 7.22463L10.8362 8.35583L11.9677 9.48703L15.3207 6.13303L14.1892 5.00183ZM10.8362 8.35583L9.66559 7.26507C9.25049 7.71056 9.0245 8.29977 9.03525 8.90858L10.635 8.88035L12.2347 8.85213C12.2386 9.07233 12.1569 9.28545 12.0067 9.44658L10.8362 8.35583ZM10.635 8.88035L9.03525 8.90858C9.04599 9.51739 9.29262 10.0983 9.72318 10.5288L10.8545 9.39745L11.9859 8.26608C12.1417 8.42182 12.2309 8.63192 12.2347 8.85213L10.635 8.88035ZM10.8545 9.39745L9.72318 10.5288C10.1537 10.9594 10.7346 11.206 11.3434 11.2168L11.3716 9.617L11.3999 8.01725C11.6201 8.02114 11.8302 8.11034 11.9859 8.26608L10.8545 9.39745ZM11.3716 9.617L11.3434 11.2168C11.9522 11.2275 12.5414 11.0015 12.9869 10.5864L11.8962 9.41583L10.8054 8.24525C10.9665 8.09511 11.1797 8.01337 11.3999 8.01725L11.3716 9.617ZM11.8962 9.41583L13.0275 10.5472L16.9115 6.6632L15.7802 5.53183L14.6488 4.40046L10.7648 8.28446L11.8962 9.41583ZM15.7802 5.53183L16.9122 6.6625C17.3523 6.22187 17.5995 5.62458 17.5995 5.00183H15.9995H14.3995C14.3995 4.77658 14.4889 4.56054 14.6481 4.40116L15.7802 5.53183ZM15.9995 5.00183H17.5995C17.5995 4.37908 17.3523 3.78179 16.9122 3.34116L15.7802 4.47183L14.6481 5.6025C14.4889 5.44312 14.3995 5.22708 14.3995 5.00183H15.9995ZM15.7802 4.47183L16.9117 3.3406L13.0227 -0.549396L11.8912 0.581829L10.7597 1.71305L14.6487 5.60305L15.7802 4.47183ZM4.10917 9.42183L2.95884 10.5339C3.17573 10.7583 3.43512 10.9372 3.72189 11.0602L4.3527 9.58979L4.98351 8.11939C5.08723 8.16389 5.18106 8.2286 5.2595 8.30974L4.10917 9.42183ZM4.3527 9.58979L3.72189 11.0602C4.00865 11.1832 4.31705 11.2479 4.62908 11.2505L4.64223 9.65051L4.65537 8.05057C4.76824 8.05149 4.87978 8.07489 4.98351 8.11939L4.3527 9.58979ZM4.64223 9.65051L4.62908 11.2505C4.94112 11.253 5.25054 11.1934 5.53928 11.0751L4.93272 9.59455L4.32615 8.11399C4.43058 8.0712 4.5425 8.04964 4.65537 8.05057L4.64223 9.65051ZM4.93272 9.59455L5.53928 11.0751C5.82803 10.9568 6.09033 10.7822 6.31087 10.5615L5.17897 9.43062L4.04706 8.29978C4.12683 8.21993 4.22171 8.15677 4.32615 8.11399L4.93272 9.59455ZM5.17897 9.43062L6.31087 10.5615C6.53141 10.3407 6.70578 10.0782 6.82381 9.78938L5.34267 9.18421L3.86153 8.57904C3.90423 8.47455 3.9673 8.37962 4.04706 8.29978L5.17897 9.43062ZM5.34267 9.18421L6.82381 9.78938C6.94183 9.50052 7.00115 9.19104 6.99829 8.87902L5.39836 8.89367L3.79842 8.90832C3.79739 8.79546 3.81884 8.68352 3.86153 8.57904L5.34267 9.18421ZM5.39836 8.89367L6.99829 8.87902C6.99543 8.56699 6.93046 8.25865 6.80717 7.972L5.33736 8.6042L3.86755 9.23639C3.82296 9.13271 3.79946 9.02118 3.79842 8.90832L5.39836 8.89367ZM5.33736 8.6042L6.80717 7.972C6.68387 7.68535 6.50472 7.42612 6.28018 7.20945L5.16917 8.36083L4.05817 9.51221C3.97695 9.43384 3.91215 9.34008 3.86755 9.23639L5.33736 8.6042ZM5.16917 8.36083L6.30088 7.2298L2.94288 3.8698L1.81117 5.00083L0.679463 6.13186L4.03746 9.49186L5.16917 8.36083ZM1.81117 5.00083L2.94254 6.1322L6.29554 2.7792L5.16417 1.64783L4.0328 0.516458L0.679801 3.86946L1.81117 5.00083ZM5.16417 1.64783L6.25493 2.81841C6.48581 2.60327 6.671 2.34383 6.79944 2.05556L5.33795 1.40437L3.87646 0.753175C3.92292 0.648905 3.98991 0.555065 4.07342 0.477251L5.16417 1.64783ZM5.33795 1.40437L6.79944 2.05556C6.92788 1.7673 6.99695 1.45612 7.00251 1.14058L5.40276 1.11235L3.80301 1.08413C3.80503 0.969994 3.83001 0.857439 3.87646 0.753175L5.33795 1.40437ZM5.40276 1.11235L7.00251 1.14058C7.00808 0.82504 6.95004 0.511615 6.83185 0.219001L5.34829 0.818232L3.86474 1.41746C3.82199 1.31162 3.801 1.19826 3.80301 1.08413L5.40276 1.11235ZM5.34829 0.818232L6.83185 0.219001C6.71365 -0.0736105 6.53774 -0.339424 6.31458 -0.56258L5.18321 0.568791L4.05184 1.70016C3.97112 1.61944 3.90749 1.5233 3.86474 1.41746L5.34829 0.818232ZM5.18321 0.568791L6.31458 -0.56258C6.09143 -0.785735 5.82561 -0.961653 5.533 -1.07984L4.93377 0.403707L4.33454 1.88726C4.2287 1.84451 4.13256 1.78088 4.05184 1.70016L5.18321 0.568791ZM4.93377 0.403707L5.533 -1.07984C5.24038 -1.19804 4.92696 -1.25608 4.61142 -1.25051L4.63965 0.349238L4.66788 1.94899C4.55375 1.951 4.44038 1.93001 4.33454 1.88726L4.93377 0.403707ZM4.63965 0.349238L4.61142 -1.25051C4.29589 -1.24495 3.98471 -1.17588 3.69644 -1.04744L4.34763 0.414048L4.99883 1.87554C4.89456 1.922 4.782 1.94698 4.66788 1.94899L4.63965 0.349238ZM4.34763 0.414048L3.69644 -1.04744C3.40818 -0.918998 3.14874 -0.733811 2.93359 -0.502926L4.10417 0.587829L5.27475 1.67858C5.19693 1.7621 5.10309 1.82908 4.99883 1.87554L4.34763 0.414048ZM4.10417 0.587829L2.9728 -0.543542L-0.9112 3.34046L0.220172 4.47183L1.35154 5.6032L5.23554 1.7192L4.10417 0.587829ZM0.220172 4.47183L-0.911903 3.34116C-1.35198 3.78179 -1.59917 4.37908 -1.59917 5.00183H0.000831604H1.60083C1.60083 5.22708 1.51142 5.44312 1.35225 5.6025L0.220172 4.47183ZM0.000831604 5.00183H-1.59917C-1.59917 5.62458 -1.35198 6.22187 -0.911903 6.6625L0.220172 5.53183L1.35225 4.40116C1.51142 4.56054 1.60083 4.77658 1.60083 5.00183H0.000831604ZM0.220172 5.53183L-0.911345 6.66305L2.97766 10.5531L4.10917 9.42183L5.24069 8.2906L1.35169 4.4006L0.220172 5.53183Z"
			fill="black"
			fill-opacity="0.75"
			mask="url(#path-1-inside-1_651_3768)"
		/>
	</svg>
);

export const GoogleSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		viewBox="0 0 25 24"
		fill="none"
	>
		<g clipPath="url(#clip0_16614_6017)">
			<path
				d="M24.266 12.2764C24.266 11.4607 24.1999 10.6406 24.0588 9.83807H12.74V14.4591H19.2217C18.9528 15.9494 18.0885 17.2678 16.823 18.1056V21.1039H20.69C22.9608 19.0139 24.266 15.9274 24.266 12.2764Z"
				fill="#4285F4"
			/>
			<path
				d="M12.7401 24.0008C15.9766 24.0008 18.7059 22.9382 20.6945 21.1039L16.8276 18.1055C15.7517 18.8375 14.3627 19.252 12.7445 19.252C9.61388 19.252 6.95946 17.1399 6.00705 14.3003H2.0166V17.3912C4.05371 21.4434 8.2029 24.0008 12.7401 24.0008Z"
				fill="#34A853"
			/>
			<path
				d="M6.00253 14.3003C5.49987 12.8099 5.49987 11.1961 6.00253 9.70575V6.61481H2.01649C0.31449 10.0056 0.31449 14.0004 2.01649 17.3912L6.00253 14.3003Z"
				fill="#FBBC04"
			/>
			<path
				d="M12.7401 4.74966C14.4509 4.7232 16.1044 5.36697 17.3434 6.54867L20.7695 3.12262C18.6001 1.0855 15.7208 -0.034466 12.7401 0.000808666C8.2029 0.000808666 4.05371 2.55822 2.0166 6.61481L6.00264 9.70575C6.95064 6.86173 9.60947 4.74966 12.7401 4.74966Z"
				fill="#EA4335"
			/>
		</g>
		<defs>
			<clipPath id="clip0_16614_6017">
				<rect width="24" height="24" fill="white" transform="translate(0.5)" />
			</clipPath>
		</defs>
	</svg>
);

export const ArrowDownSvg: IconComponent = () => (
	<svg
		width="17"
		height="16"
		viewBox="0 0 17 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M5.33301 6.66667L8.66634 10L11.9997 6.66667"
			stroke="black"
			stroke-opacity="0.45"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);

export const CalendarSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M5.34375 1.125C5.56753 1.125 5.78214 1.21389 5.94037 1.37213C6.09861 1.53036 6.1875 1.74497 6.1875 1.96875V3.375H11.8125V1.96875C11.8125 1.74497 11.9014 1.53036 12.0596 1.37213C12.2179 1.21389 12.4325 1.125 12.6562 1.125C12.88 1.125 13.0946 1.21389 13.2529 1.37213C13.4111 1.53036 13.5 1.74497 13.5 1.96875V3.375H15.75C16.0484 3.375 16.3345 3.49353 16.5455 3.7045C16.7565 3.91548 16.875 4.20163 16.875 4.5V15.75C16.875 16.0484 16.7565 16.3345 16.5455 16.5455C16.3345 16.7565 16.0484 16.875 15.75 16.875H2.25C1.95163 16.875 1.66548 16.7565 1.4545 16.5455C1.24353 16.3345 1.125 16.0484 1.125 15.75V4.5C1.125 4.20163 1.24353 3.91548 1.4545 3.7045C1.66548 3.49353 1.95163 3.375 2.25 3.375H4.5V1.96875C4.5 1.74497 4.58889 1.53036 4.74713 1.37213C4.90536 1.21389 5.11997 1.125 5.34375 1.125ZM2.8125 5.0625V6.75H15.1875V5.0625H2.8125ZM2.8125 15.1875V8.4375H15.1875V15.1875H2.8125ZM12.375 12.375C12.6734 12.375 12.9595 12.2565 13.1705 12.0455C13.3815 11.8345 13.5 11.5484 13.5 11.25C13.5 10.9516 13.3815 10.6655 13.1705 10.4545C12.9595 10.2435 12.6734 10.125 12.375 10.125C12.0766 10.125 11.7905 10.2435 11.5795 10.4545C11.3685 10.6655 11.25 10.9516 11.25 11.25C11.25 11.5484 11.3685 11.8345 11.5795 12.0455C11.7905 12.2565 12.0766 12.375 12.375 12.375Z"
			fill="black"
			fill-opacity="0.85"
		/>
	</svg>
);

export const CloseSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="10"
		height="10"
		viewBox="0 0 10 10"
		fill="none"
	>
		<path
			d="M2.81543 7.18458L5.00001 5L7.1846 7.18458M7.1846 2.81541L4.9996 5L2.81543 2.81541"
			stroke="black"
			stroke-opacity="0.45"
			stroke-width="0.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);

export const ImageSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="12"
		height="12"
		viewBox="0 0 12 12"
		fill="none"
	>
		<g clipPath="url(#clip0_797_16320)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.52476 0H9.49068C9.82021 -9.4107e-09 10.1465 0.0649999 10.4509 0.191287C10.7554 0.317575 11.032 0.502676 11.265 0.736018C11.498 0.969361 11.6828 1.24637 11.8088 1.55124C11.9349 1.8561 11.9997 2.18284 11.9996 2.5128V9.4878C11.9996 9.81776 11.9347 10.1445 11.8086 10.4493C11.6825 10.7541 11.4976 11.0311 11.2646 11.2644C11.0315 11.4977 10.7549 11.6827 10.4504 11.8089C10.1459 11.9352 9.81961 12.0001 9.49009 12H2.52476C2.19518 12.0001 1.86882 11.9351 1.56431 11.8089C1.2598 11.6826 0.983124 11.4975 0.750077 11.2642C0.51703 11.0308 0.332182 10.7538 0.206095 10.4489C0.0800067 10.144 0.0151496 9.81721 0.0152283 9.4872V2.5128C0.0155459 1.84646 0.280044 1.20751 0.750604 0.736333C1.22116 0.265161 1.85929 0.000317985 2.52476 0ZM2.52476 1.2C1.8003 1.2 1.21367 1.788 1.21367 2.5128V9.4878C1.21367 10.212 1.8009 10.8 2.52476 10.8H9.49068C10.2139 10.8 10.8012 10.212 10.8012 9.4872V2.5128C10.8012 1.788 10.2139 1.2 9.49009 1.2H2.52476Z"
				fill="#0E49B5"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.14732 5.35449C9.02069 5.24857 8.86129 5.1899 8.6963 5.18848C8.53131 5.18706 8.37093 5.24297 8.2425 5.34669L5.10019 7.89489C4.88135 8.07221 4.60932 8.17069 4.32783 8.1745C4.04634 8.17831 3.77175 8.08723 3.54821 7.91589L2.71829 7.27989C2.70761 7.27176 2.69437 7.26771 2.68096 7.26848C2.66756 7.26925 2.65487 7.27479 2.64519 7.28409L1.02849 8.83329C0.972354 8.89101 0.90518 8.93682 0.830979 8.96798C0.756778 8.99914 0.677069 9.01502 0.596606 9.01467C0.516144 9.01432 0.436576 8.99774 0.362649 8.96594C0.288722 8.93413 0.22195 8.88774 0.166316 8.82953C0.110681 8.77132 0.067324 8.70249 0.0388301 8.62715C0.0103362 8.5518 -0.00271064 8.47148 0.000467679 8.39097C0.003646 8.31047 0.0229844 8.23143 0.0573294 8.15857C0.0916744 8.08571 0.140323 8.02052 0.200372 7.96689L1.81647 6.41709C2.0328 6.20974 2.31606 6.08669 2.61508 6.07018C2.9141 6.05368 3.20916 6.1448 3.44694 6.32709L4.27686 6.96309C4.28685 6.97079 4.29912 6.97492 4.31172 6.97481C4.32432 6.9747 4.33652 6.97037 4.34637 6.96249L7.48748 4.41429C7.83188 4.1353 8.26236 3.98473 8.70534 3.98834C9.14832 3.99196 9.5763 4.14952 9.91612 4.43409L11.7857 6.00189C11.9075 6.10414 11.9838 6.25064 11.9977 6.40919C12.0116 6.56773 11.9621 6.72532 11.86 6.84729C11.7579 6.96927 11.6116 7.04563 11.4532 7.05958C11.2949 7.07354 11.1375 7.02394 11.0157 6.92169L9.14732 5.35449Z"
				fill="#0E49B5"
			/>
			<path
				d="M4.9774 3.984C4.9774 4.24497 4.87387 4.49526 4.68957 4.67979C4.50528 4.86433 4.25532 4.968 3.99468 4.968C3.73405 4.968 3.48409 4.86433 3.29979 4.67979C3.1155 4.49526 3.01196 4.24497 3.01196 3.984C3.01196 3.72303 3.1155 3.47274 3.29979 3.28821C3.48409 3.10367 3.73405 3 3.99468 3C4.25532 3 4.50528 3.10367 4.68957 3.28821C4.87387 3.47274 4.9774 3.72303 4.9774 3.984Z"
				fill="#0E49B5"
			/>
		</g>
		<defs>
			<clipPath id="clip0_797_16320">
				<rect width="12" height="12" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

export const NameSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="12"
		height="12"
		viewBox="0 0 12 12"
		fill="none"
	>
		<g clipPath="url(#clip0_797_16331)">
			<path
				d="M9.33333 9.33333H7.27614C6.68221 9.33333 6.38476 8.61524 6.80474 8.19526C6.92976 8.07024 7.09933 8 7.27614 8H9.33333M2.66667 9.33333V8.29359C2.66667 7.89245 2.82734 7.50803 3.11278 7.2262L7.93333 2.46667C8.06667 2.33333 8.26667 2.33333 8.4 2.46667L9.6 3.66667C9.73333 3.8 9.73333 4 9.6 4.13333L4.33333 9.33333M9.16667 1.33333C9.99509 1.33333 10.6667 2.00491 10.6667 2.83333V9.16667C10.6667 9.9951 9.99509 10.6667 9.16667 10.6667H2.83333C2.0049 10.6667 1.33333 9.99509 1.33333 9.16667V2.83333C1.33333 2.0049 2.00491 1.33333 2.83333 1.33333H6H9.16667ZM10.6667 0H1.33333C0.6 0 0 0.6 0 1.33333V10.6667C0 11.4 0.6 12 1.33333 12H10.6667C11.4 12 12 11.4 12 10.6667V1.33333C12 0.6 11.4 0 10.6667 0Z"
				fill="#0E49B5"
			/>
		</g>
		<defs>
			<clipPath id="clip0_797_16331">
				<rect width="12" height="12" rx="3" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

export const CheckboxSvg: IconComponent = () => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M3 8.5L6 11.5L12.5 5"
			stroke="white"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);

export const CountryArrowDownSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
	>
		<path
			d="M9.33334 13.3335L16 20.0002L22.6667 13.3335"
			stroke="currentColor"
			stroke-width="3"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);

export const LeftArrowSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.7072 5.29289C16.0977 5.68342 16.0977 6.31658 15.7072 6.70711L10.4143 12L15.7072 17.2929C16.0977 17.6834 16.0977 18.3166 15.7072 18.7071C15.3166 19.0976 14.6835 19.0976 14.2929 18.7071L9.00005 13.4142C8.99089 13.4051 8.9816 13.3958 8.97219 13.3864C8.83076 13.2451 8.66239 13.077 8.53713 12.9128C8.38593 12.7146 8.20715 12.4101 8.20715 12C8.20715 11.5899 8.38593 11.2854 8.53713 11.0872C8.66239 10.923 8.83076 10.7549 8.97219 10.6136C8.9816 10.6042 8.99089 10.5949 9.00005 10.5858L14.2929 5.29289C14.6835 4.90237 15.3166 4.90237 15.7072 5.29289ZM10.1249 11.6965L10.1258 11.6979L10.1249 11.6965ZM10.1258 12.3022L10.1249 12.3035L10.1258 12.3022Z"
			fill="currentColor"
			fillOpacity="0.45"
		/>
	</svg>
);

export const RightArrowSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.39641 5.29289C8.78693 4.90237 9.4201 4.90237 9.81062 5.29289L15.1035 10.5858C15.1127 10.5949 15.122 10.6042 15.1314 10.6136C15.2728 10.7549 15.4412 10.923 15.5664 11.0872C15.7176 11.2854 15.8964 11.5899 15.8964 12C15.8964 12.4101 15.7176 12.7146 15.5664 12.9128C15.4412 13.077 15.2728 13.2451 15.1314 13.3864C15.122 13.3958 15.1127 13.4051 15.1035 13.4142L9.81062 18.7071C9.4201 19.0976 8.78693 19.0976 8.39641 18.7071C8.00588 18.3166 8.00588 17.6834 8.39641 17.2929L13.6893 12L8.39641 6.70711C8.00588 6.31658 8.00588 5.68342 8.39641 5.29289ZM13.9787 12.3035L13.9777 12.3021L13.9787 12.3035ZM13.9778 11.6978L13.9787 11.6965L13.9778 11.6978Z"
			fill="currentColor"
			fillOpacity="0.45"
		/>
	</svg>
);

export const MoreSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="currentColor"
	>
		<path
			d="M3 9C3 9.19891 3.07902 9.38968 3.21967 9.53033C3.36032 9.67098 3.55109 9.75 3.75 9.75C3.94891 9.75 4.13968 9.67098 4.28033 9.53033C4.42098 9.38968 4.5 9.19891 4.5 9C4.5 8.80109 4.42098 8.61032 4.28033 8.46967C4.13968 8.32902 3.94891 8.25 3.75 8.25C3.55109 8.25 3.36032 8.32902 3.21967 8.46967C3.07902 8.61032 3 8.80109 3 9ZM8.25 9C8.25 9.19891 8.32902 9.38968 8.46967 9.53033C8.61032 9.67098 8.80109 9.75 9 9.75C9.19891 9.75 9.38968 9.67098 9.53033 9.53033C9.67098 9.38968 9.75 9.19891 9.75 9C9.75 8.80109 9.67098 8.61032 9.53033 8.46967C9.38968 8.32902 9.19891 8.25 9 8.25C8.80109 8.25 8.61032 8.32902 8.46967 8.46967C8.32902 8.61032 8.25 8.80109 8.25 9ZM13.5 9C13.5 9.19891 13.579 9.38968 13.7197 9.53033C13.8603 9.67098 14.0511 9.75 14.25 9.75C14.4489 9.75 14.6397 9.67098 14.7803 9.53033C14.921 9.38968 15 9.19891 15 9C15 8.80109 14.921 8.61032 14.7803 8.46967C14.6397 8.32902 14.4489 8.25 14.25 8.25C14.0511 8.25 13.8603 8.32902 13.7197 8.46967C13.579 8.61032 13.5 8.80109 13.5 9Z"
			fill="currentColor"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const HomeSearchSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14"
		height="15"
		viewBox="-1 -1 14 15"
		fill="none"
	>
		<path
			d="M7.32996 14.876L7.32019 14.874M7.32996 14.876L7.32703 14.8691L7.32214 14.8701L7.32019 14.874M7.32996 14.876L7.33777 14.874M7.32996 14.876L7.33093 14.8691L7.33484 14.8701L7.33777 14.874M7.32019 14.874L7.31531 14.8701H7.32019V14.874ZM7.33777 14.874L7.33875 14.873V14.8701H7.33582L7.33777 14.874Z"
			stroke="black"
			strokeOpacity="0.45"
			strokeWidth="1.2"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.99999 0.333496C5.09638 0.333573 4.2059 0.549739 3.40282 0.963959C2.59975 1.37818 1.90738 1.97844 1.38348 2.71467C0.859572 3.45089 0.519326 4.30173 0.391125 5.19619C0.262924 6.09066 0.350485 7.00281 0.646505 7.85655C0.942524 8.71029 1.43842 9.48087 2.09281 10.104C2.7472 10.7271 3.54112 11.1847 4.40833 11.4386C5.27553 11.6924 6.19088 11.7353 7.078 11.5634C7.96512 11.3916 8.79828 11.0101 9.50799 10.4508L11.9427 12.8855C12.0684 13.0069 12.2368 13.0741 12.4116 13.0726C12.5864 13.0711 12.7536 13.001 12.8772 12.8774C13.0008 12.7538 13.0709 12.5866 13.0724 12.4118C13.074 12.237 13.0068 12.0686 12.8853 11.9428L10.4507 9.50816C11.1093 8.67257 11.5194 7.66843 11.6341 6.61065C11.7487 5.55286 11.5632 4.48418 11.0988 3.52689C10.6344 2.56961 9.90991 1.7624 9.00819 1.19765C8.10646 0.6329 7.06396 0.333425 5.99999 0.333496ZM1.66665 6.00016C1.66665 4.85089 2.1232 3.74869 2.93586 2.93603C3.74851 2.12338 4.85071 1.66683 5.99999 1.66683C7.14926 1.66683 8.25146 2.12338 9.06412 2.93603C9.87677 3.74869 10.3333 4.85089 10.3333 6.00016C10.3333 7.14943 9.87677 8.25163 9.06412 9.06429C8.25146 9.87695 7.14926 10.3335 5.99999 10.3335C4.85071 10.3335 3.74851 9.87695 2.93586 9.06429C2.1232 8.25163 1.66665 7.14943 1.66665 6.00016Z"
			fill="black"
			fillOpacity="0.45"
		/>
		<path
			d="M5.99982 0.933105C6.83219 0.93305 7.65013 1.13833 8.38165 1.52783L8.68927 1.70654C9.39469 2.14835 9.97922 2.75573 10.3924 3.47412L10.5594 3.78857C10.9227 4.53745 11.0945 5.36278 11.0633 6.19092L11.0379 6.54639C10.9354 7.49205 10.5682 8.39018 9.97931 9.13721L9.64923 9.55518L12.4539 12.3599L12.4676 12.3813L12.4725 12.4067C12.4724 12.4155 12.4709 12.4242 12.4676 12.4321L12.4529 12.4526C12.4406 12.465 12.4236 12.472 12.4061 12.4722L12.3807 12.4683L12.3592 12.4536L9.55548 9.6499L9.13654 9.97998C8.58128 10.4175 7.94125 10.7327 7.25861 10.9077L6.96368 10.9741C6.17057 11.1277 5.35228 11.0898 4.57697 10.8628C3.89844 10.6641 3.26974 10.3263 2.73126 9.87158L2.50665 9.66943C1.99475 9.182 1.59128 8.59365 1.32111 7.94287L1.21368 7.65967C0.949107 6.89651 0.870634 6.0813 0.985168 5.28174C1.09977 4.48219 1.40366 3.72114 1.87189 3.06299C2.28167 2.48714 2.80716 2.00386 3.4129 1.64404L3.67755 1.49756C4.30592 1.17345 4.99449 0.98494 5.69806 0.942871L5.99982 0.933105ZM5.99982 1.06689C4.77331 1.06694 3.59418 1.52395 2.68927 2.34326L2.51154 2.51221C1.58651 3.43736 1.06622 4.6922 1.06622 6.00049C1.0663 7.22686 1.5234 8.40618 2.34259 9.31104L2.51154 9.48877C3.43667 10.4139 4.69151 10.9331 5.99982 10.9331C7.3081 10.9331 8.56294 10.4138 9.4881 9.48877C10.4132 8.56367 10.9333 7.30877 10.9334 6.00049C10.9334 4.77384 10.4765 3.59395 9.65704 2.68896L9.4881 2.51221C8.56292 1.58703 7.30822 1.06689 5.99982 1.06689Z"
			stroke="black"
			strokeOpacity="0.45"
			strokeWidth="1.2"
		/>
	</svg>
);

export const ListSearchIcon: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="17"
		height="18"
		viewBox="0 0 17 18"
		fill="none"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.75021 0.666664C6.62071 0.66676 5.5076 0.936968 4.50376 1.45474C3.49992 1.97252 2.63446 2.72285 1.97957 3.64313C1.32469 4.56341 0.899386 5.62695 0.739135 6.74503C0.578884 7.86311 0.688336 9.00331 1.05836 10.0705C1.42838 11.1377 2.04825 12.1009 2.86624 12.8798C3.68423 13.6587 4.67663 14.2306 5.76064 14.548C6.84465 14.8654 7.98883 14.9189 9.09773 14.7041C10.2066 14.4893 11.2481 14.0125 12.1352 13.3133L15.1785 16.3567C15.3357 16.5085 15.5462 16.5925 15.7647 16.5906C15.9832 16.5887 16.1922 16.501 16.3467 16.3465C16.5012 16.192 16.5889 15.983 16.5908 15.7645C16.5927 15.546 16.5087 15.3355 16.3569 15.1783L13.3135 12.135C14.1369 11.0905 14.6495 9.83533 14.7928 8.5131C14.9361 7.19087 14.7042 5.85501 14.1237 4.65841C13.5433 3.4618 12.6376 2.45279 11.5105 1.74686C10.3833 1.04092 9.08018 0.666575 7.75021 0.666664ZM2.33354 7.75C2.33354 6.31341 2.90423 4.93566 3.92005 3.91984C4.93587 2.90401 6.31362 2.33333 7.75021 2.33333C9.1868 2.33333 10.5646 2.90401 11.5804 3.91984C12.5962 4.93566 13.1669 6.31341 13.1669 7.75C13.1669 9.18659 12.5962 10.5643 11.5804 11.5802C10.5646 12.596 9.1868 13.1667 7.75021 13.1667C6.31362 13.1667 4.93587 12.596 3.92005 11.5802C2.90423 10.5643 2.33354 9.18659 2.33354 7.75Z"
			fill="black"
			fillOpacity="0.45"
		/>
	</svg>
);

export const ListArrowDownSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
	>
		<path
			d="M7 10L12 15L17 10"
			stroke="black"
			strokeOpacity="0.45"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const LinkOutSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="22"
		height="22"
		viewBox="0 0 22 22"
		fill="none"
	>
		<path
			d="M12.375 9.625L19.25 2.75M19.25 2.75H14.6667M19.25 2.75V7.33333M19.25 12.8333V17.4167C19.25 17.9029 19.0568 18.3692 18.713 18.713C18.3692 19.0568 17.9029 19.25 17.4167 19.25H4.58333C4.0971 19.25 3.63079 19.0568 3.28697 18.713C2.94315 18.3692 2.75 17.9029 2.75 17.4167V4.58333C2.75 4.0971 2.94315 3.63079 3.28697 3.28697C3.63079 2.94315 4.0971 2.75 4.58333 2.75H9.16667"
			stroke="#1D39B7"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);

export const AddSvg: IconComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="15"
		height="15"
		viewBox="0 0 15 15"
		fill="none"
	>
		<path
			d="M6.875 8.125H3.75C3.57292 8.125 3.42459 8.065 3.305 7.945C3.18542 7.825 3.12542 7.67667 3.125 7.5C3.12459 7.32333 3.18459 7.175 3.305 7.055C3.42542 6.935 3.57375 6.875 3.75 6.875H6.875V3.75C6.875 3.57292 6.935 3.42459 7.055 3.305C7.175 3.18542 7.32333 3.12542 7.5 3.125C7.67667 3.12459 7.82521 3.18459 7.94563 3.305C8.06604 3.42542 8.12584 3.57375 8.125 3.75V6.875H11.25C11.4271 6.875 11.5756 6.935 11.6956 7.055C11.8156 7.175 11.8754 7.32333 11.875 7.5C11.8746 7.67667 11.8146 7.82521 11.695 7.94563C11.5754 8.06604 11.4271 8.12584 11.25 8.125H8.125V11.25C8.125 11.4271 8.065 11.5756 7.945 11.6956C7.825 11.8156 7.67667 11.8754 7.5 11.875C7.32333 11.8746 7.175 11.8146 7.055 11.695C6.935 11.5754 6.875 11.4271 6.875 11.25V8.125Z"
			fill="black"
			fill-opacity="0.35"
		/>
	</svg>
);

export const CloseSvgLg: IconComponent = () => (
	<svg
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
		className="text-gray-400"
	>
		<path
			d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const MailSvg: IconComponent = ({ color, style, ...props }) => {
	const strokeColor = color || (style?.color) || 'currentColor';
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="8"
			height="8"
			viewBox="0 0 24 24"
			fill="none"
			style={{ color: strokeColor, ...style }}
			{...props}
		>
			<path
				d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
				stroke="currentColor"
				strokeWidth="2"
				fill="none"
			/>
			<polyline
				points="22,6 12,13 2,6"
				stroke="currentColor"
				strokeWidth="2"
				fill="none"
			/>
		</svg>
	);
};

export const TagCloseSvg: IconComponent = ({ color, style, ...props }) => {
	const strokeColor = color || (style?.color) || 'currentColor';
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="7"
			height="7"
			viewBox="0 0 8 8"
			fill="none"
			style={{ color: strokeColor, ...style }}
			{...props}
		>
			<path
				d="M6 2L2 6M2 2L6 6"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};